import { Injectable, ModuleWithProviders, Inject, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AngularFirestore } from 'angularfire2/firestore';
import { DadosServiceAbstract } from '../../../models/dados.service-abstract';

import { Categorias, ICategorias } from '../../../models/categorias.model';
import { Produtos, IProdutos } from '../../../models/produtos.model';
import { Fornecedores, IFornecedores } from '../../../models/fornecedores.model';
import { NaoEncontrei } from '../../../models/naoEncontrei.model';
import { CarrinhoItemsModel } from '../../../models/carrinhoItems.model';
import { DataModel } from '../../../models/data.model';
//import { UsersService } from '../../../models/usuarios.service';

@Injectable()
export class DadosService extends DadosServiceAbstract {
  categoriaClass: Categorias;
  produtosClass: Produtos;
  fornecedoresClass: Fornecedores;
  listaNaoEncontradosClass: NaoEncontrei;
  pedidosNovosClass: CarrinhoItemsModel;

  get versao() {
    return DataModel.versao;
  }

  toDateLocale(d) {
    return DataModel.toDateLocale(d);
  }

  toDateAge(d) {
    return DataModel.toDateAge(d);
  }


  getBadge(key) {
    let x = 0;
    if (key == "Monitoramento") {
      x = this.pedidosNovosClass.pedidosCount;
      //console.log('Monitoramento', x);
    }
    return x;
  }

  set user(x) {
    this.pedidosNovosClass.user = x;
  }
  get user() {
    return this.pedidosNovosClass.user;
  }

  init() {
    console.log('INIT()');
    if (!this.pedidosNovosClass) {
      this.pedidosNovosClass = new CarrinhoItemsModel(this.db, null);
    }
    if (!this.categoriaClass) {
      this.categoriaClass = new Categorias(this.db);
    }
    if (!this.produtosClass) {
      this.produtosClass = new Produtos(this.db, 0, false);
    }
    if (!this.fornecedoresClass) {
      this.fornecedoresClass = new Fornecedores(this.db);
    }
    if (!this.listaNaoEncontradosClass) {
      this.listaNaoEncontradosClass = new NaoEncontrei(this.db, null);
    }


  }

  getCategoria(codigo: Number, proc) {
    return this.categoriaClass.getCategoria(codigo, proc);
  }
  getFornecedor(codigo: number, proc) {
    console.log('getFornecedor', codigo);
    return this.fornecedoresClass.getFornecedor(codigo, proc);
  }
  getProduto(codigo: string, proc) {
    return this.produtosClass.getProduto(codigo, proc);
  }

  getNaoEncontrados(fornec: number) {
    this.listaNaoEncontradosClass.fornecedor = fornec;
    this.listaNaoEncontradosClass.FDados
  }



}
